import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;

const jsonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const multipartHeaders = {
  "Content-Type": "multipart/form-data",
  Accept: "application/json",
};

const extractErrorMessage = (error) => {
  const data = error?.response?.data;
  if (!data) return error.message || "Something went wrong";
  // Joi-style { errors: [...] } once validators are wired in, plus the
  // current manual-check shape { error: "..." } / { message: "..." }
  if (Array.isArray(data.errors)) return data.errors.join(", ");
  return data.error || data.message || "Something went wrong";
};

const request = async (url, options = {}) => {
  try {
    const response = await axios(url, { withCredentials: true, ...options });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(extractErrorMessage(error));
  }
};

// ─────────────────────────────────────────────
// ADMIN — ad management
// ─────────────────────────────────────────────

export const createAd = (formData) =>
  request(`${API_URL}/admin/ads`, {
    method: "POST",
    headers: multipartHeaders,
    data: formData,
  });

// data may be a FormData (image replaced) or a plain object (no image
// change) — either is valid multipart/form-data on the backend since
// multer parses non-file fields into req.body either way.
export const editAd = ({ id, data }) =>
  request(`${API_URL}/admin/ads/${id}`, {
    method: "PATCH",
    headers: multipartHeaders,
    data,
  });

export const toggleAdStatus = ({ id, status }) =>
  request(`${API_URL}/admin/ads/${id}/status`, {
    method: "PATCH",
    headers: jsonHeaders,
    data: { status },
  });

export const deleteAd = (id) =>
  request(`${API_URL}/admin/ads/${id}`, {
    method: "DELETE",
    headers: jsonHeaders,
  });

export const restoreAd = (id) =>
  request(`${API_URL}/admin/ads/${id}/restore`, {
    method: "PATCH",
    headers: jsonHeaders,
    data: {},
  });

export const getAdById = (id) =>
  request(`${API_URL}/admin/ads/${id}`, {
    method: "GET",
    headers: jsonHeaders,
  });

// params: { position, status, paid, organization, includeDeleted }
export const getAllAds = (params = {}) =>
  request(`${API_URL}/admin/ads`, {
    method: "GET",
    headers: jsonHeaders,
    params,
  });

// ─────────────────────────────────────────────
// ADMIN — reference data
// ─────────────────────────────────────────────

export const getPositions = () =>
  request(`${API_URL}/admin/positions`, {
    method: "GET",
    headers: jsonHeaders,
  });

// ─────────────────────────────────────────────
// ADMIN — reporting
// ─────────────────────────────────────────────

export const getAdStats = (id) =>
  request(`${API_URL}/admin/ads/${id}/stats`, {
    method: "GET",
    headers: jsonHeaders,
  });

// params: { excludeDeleted }
export const getAdsSummary = (params = {}) =>
  request(`${API_URL}/admin/ads-stats/summary`, {
    method: "GET",
    headers: jsonHeaders,
    params,
  });